import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=2079a819&scoped=true"
import script from "./addConfig.vue?vue&type=script&lang=js"
export * from "./addConfig.vue?vue&type=script&lang=js"
import style0 from "./addConfig.vue?vue&type=style&index=0&id=2079a819&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079a819",
  null
  
)

export default component.exports